<template>
  <div class="col-sm-12">
    <div
      class="data-list-item add"
      @click.stop="$emit('add')"
    >
      <div class="item-img-cont add-title">
        <i class="fa fa-plus" />
      </div>
      <div class="item-text-cont">
        <span class="item-title-add">
          {{ $t('common.add_new') }}
        </span>
        <font-awesome-icon
          icon="coins"
          class="card-body-icon"
        />
      </div>
    </div>

      <div clasS="col-12 list-container nopads">
          <Transition name="fade">
              <div v-if="resultList.length > 0" class="col-sm-12 nopads list-content result-table my-2">
                  <vue3-datatable
                      ref="resultTable"
                      :rows="resultList"
                      :columns="fields"
                      :pagination="false"
                      :sticky-header="true"
                      height="100%"
                      :sortable="true"
                      skin="bh-table-compact"
                      row-class="routa-table-row"
                      cell-class="routa-table-cell"
                  >
                  </vue3-datatable>
              </div>
          </Transition>
      </div>
  </div>
</template>

<script>
import {priceHelper} from '../mixins/PricingMixin'
import Vue3Datatable from "@bhplugin/vue3-datatable";
export default {
    name: 'PricingModelList',
    mixins: [priceHelper],
    components: {Vue3Datatable},
    data() {
        return {
            fields: [
                {field: 'id', title: 'Id', sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'model', title: this.$t('orders.pricing_model'), sort: true, headerClass: 'routa-table-header'},
            ],
            resultList: []
        }
    },
    props: {
        results: {
            type: Array,
            default: function () {
                return []
            },
        }
    },
    watch: {
        results() {
            let temp = []
            this.results.forEach(item => {
                let newItem = { ...item };
                newItem.model = this.getTitle(item)
                temp.push(newItem)
            })
            this.$nextTick(() => {
                this.resultList = temp
            })
        }
    },
    mounted() {
        this.resultList = this.results
    },
    methods: {
        getTitle: function(item) {
            return import.meta.env.VITE_APP_CURRENCY+ ' / ' + this.unitToText(item.unit1)  + (item.unit2 ? ' / ' + this.unitToText(item.unit2) : '')
        }
    }
}
</script>
